<template>
  <div class="cp_guide fadeIn animated" @touchmove.prevent>
    <transition name="fade" mode="out-in">
      <div class="mask" @click="closeGuide" @touchmove="_stopDef" @mousewheel="_stopDef">
        <div class="content" @mousewheel="_stopDef">

        </div>
      </div>
    </transition>
  </div>
</template>

<script>

import * as types from '~/store/mutation-type';
import store from '~/store/index';

export default {
  data: function () {
    return {
      show: this.propsShow
    };
  },
  mounted: function () {
  },
  methods: {
    submit() {
      this.show = false;
      this.$emit('confirm');
    },
    esc () {
      this.show = false;
    },
    _stopDef(e) {
      e.preventDefault();
    },
    closeGuide() {
      store.commit(types.SHOW_GUIDE, false);
    }
  },
  watch: {
    propsShow: function (newVal) {
      this.show = newVal;
    },
    show: function (newVal) {
      this.$emit('setDialogVisible', newVal);
    }
  },
  props: {
    'propsShow': {
      type: Boolean,
      default: false
    }
  }
};
</script>

<style lang="stylus" rel="stylesheet/stylus">
.cp_guide
  width: 100%;
  height: 100%;
  z-index 10
  position: fixed;
  top:0;
  .mask {
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.8);
    z-index: 200;
    position: fixed;
    top:0;
    left:0;
  }
  .content
    position: absolute;
    top: 1.39rem;
    left: 1.65rem;
    width 4.4rem;
    height 3.65rem
    background url('./images/guide.png') no-repeat
    background-size 100% 100%
</style>
